<template>
    <div class="font-prompt totop-div">
        <b-modal :id="modalId"
                 modal-class="modal-error-page"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base font-prompt totop-div">
                <div class="modal-base-head">
                    <img src="../../assets/icon/white@3x.png" />
                    <!-- <top-bar></top-bar> -->
                </div>
                <div class="modal-base-body totop-div">
                    <div class="modal-success-title">ยกเลิกการเป็นสมาชิกไม่สำเร็จ</div>

                   
                    <div class="totop-div">
                        <div class="modal-success-message">
                            ขออภัยไม่สามารถยกเลิก<br>การเป็นสมาชิกของท่านได้ในขณะนี้
                        </div>
                        <div class="p-2">
                            <button class="btn-black" @click="hideModal()">ปิด</button>
                        </div>
                    </div>
                </div><!-- modal-base-body -->
            </div><!-- modal-base -->
        </b-modal>
    </div>
</template>
<script>
// import TopBar from '@/components/TopBar.vue';
/**
 * @property {Vue} busModal
 *
 * @method showModal
 * @method hideModal
 */
export default {
    name: "ModalSuccessPage",
    props: {
        busModal: Object,
    },
    components: {
        // TopBar,
    },
    data: function() {
        return {
            modalId: "modal-error",
            type: "campaign", // ticket, campaign
            paramStr: "",
        };
    },
    mounted: function() {
        
        this.busModal.$on('showModal', this.showModal);
        this.busModal.$on('hideModal', this.hideModal);
             setTimeout(() => {
                window.scrollTo(0,0);
                //document.getElementByClassName("totop-div").scrollTop = 0
            }, 500);
       
    },
    methods: {
        showModal: function() {
            
            this.$bvModal.show(this.modalId);
        },
        clickSubmit: function() {
            window.location.href = "/landing/line?liff.state=" + this.paramStr;
            //%3Ftarget_page%3Dcampaign%26campaignid%3D91677
            ///landing/line?liff.state=%3FboutiqueId%3Dxxxx%26target_page%3Dcampaign%26campaignid%3D91677
            // window.location.href = "/landing/line?liff.state=%3FboutiqueId%3Dxxxx%26sourceId%3Dyyyy%26target_page%3Dcampaign%26campaignid%3D549070&state=line_authorize";
        },
        hideModal: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/base/component/modal/ModalFullScreen.scss";

    .modal-error-page {
        @extend %modal-base;

        .modal-base-head {

            padding: 15px 80px;

            img {
                width: 100%;
            }
        }
        .modal-dialog {

            .modal-content{

                .modal-body {
                        background-color: white;
                }
            }
        }

        .modal-success-title {
            font-size: 1.2rem;
            font-weight: bold;
            text-decoration: underline;
            text-align: center;
            padding-top: 25vh;
        }

        .modal-success-message {
            text-align: center;
            line-height: 1.2;
            font-size: 0.9rem;
            padding: 20px;
        }
    }
</style>
